import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./scss/App.scss";
import TopHeader from "./components/header/TopHeader";
import DocumentDetail from "./components/main/document/DocumentDetail";
import Footer from "./components/footer/Footer";
import Search from "./components/main/search";
import NotFound from "./components/main/notfound";


function App() {
  return (
    <Router>
      <div className="App">
        <header className="header">
          <div className="header-wrapper">
            <TopHeader />
          </div>
        </header>
        <main>
          <Routes>
          <Route path='*' element={<NotFound />} />
            <Route path="/" element={<Search />} />
            <Route path="/dokument/:id" element={<DocumentDetail />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
